import { Link } from "react-router-dom";
import "./styles/arcadeAntics.css";

const projects = [
  { title: "Bored Room",        path: "/arcade-antics/bored-room" },
  { title: "Spaceship Control", path: "/arcade-antics/spaceship-control" },
];

export default function ArcadeAntics() {
  return (
    <div style={{
      color: 'white',
      minHeight: '80vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      gap: '40px',
    }}>
      <h1 style={{ fontSize: '2rem', margin: 0 }}>Arcade Antics</h1>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
        {projects.map(p => (
          <Link
            key={p.path}
            to={p.path}
            className="aa-tile"
          >
            {p.title}
          </Link>
        ))}
      </div>
    </div>
  );
}
